import { clsx, type ClassValue } from "clsx";
import { formatDistanceToNow } from "date-fns";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateTime(isoDate: string | undefined): string {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  const formatted = date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  // Add period after month abbreviation
  return formatted.replace(/^([A-Za-z]{3}) /, "$1. ");
}

export function formatRelativeTime(isoDate: string | undefined): string {
  if (!isoDate) return "";

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return "";

  return formatDistanceToNow(date, { addSuffix: true });
}

export function capitalize(str: string | undefined): string {
  if (!str) return "";
  // Handle underscore-separated strings (convert to title case)
  if (str.includes("_")) {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  // Regular capitalization for single words
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
